import React from 'react';
import "./style.scss";

function BackgroundImage({children, className, style, content, ...rest}) {
  if (!content) return null;
  if (!content.background_image) return children;
  const {image, settings} = content.background_image;
  const {lightness, focal_point} = settings;
  const backgroundColor = lightness ? [lightness, lightness, lightness].join(", ") : "255, 255, 255";

  return (
    <div
      className={[className, "BackgroundImage"].join(" ")}
      style={image === null ? null : {
        ...style,
        backgroundImage: "url('" + image + "')",
        backgroundColor: `rgb(${backgroundColor})`,
        backgroundPosition: `50% ${focal_point}%`,
      }}
      {...rest}
    >
      {children}
    </div>
  );
}

export default BackgroundImage;
